import React, { ComponentType } from 'react';
import { useSelector } from 'react-redux';
import LoadingError from 'Molecules/LoadingError/LoadingError';
import { selectNavItems } from 'state/Navigation/navigationSlice';

type PageName = 'budget';

interface WithPagePermissionOptions {
  pageName: PageName;
  headerHeight?: string;
}

function withPagePermission<P extends object>(
  WrappedComponent: ComponentType<P>,
  options: WithPagePermissionOptions
) {
  const { pageName, headerHeight = '17rem' } = options;

  const WithPermissionComponent: React.FC<P> = (props) => {
    const navItems = useSelector(selectNavItems);
    const canShowPage = navItems.find(
      (item) => item.page === pageName
    )?.canShow;

    if (!canShowPage) {
      return <LoadingError headerHeight={headerHeight} errorCode={403} />;
    }

    return <WrappedComponent {...props} />;
  };

  const wrappedComponentName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithPermissionComponent.displayName = `withPagePermission(${wrappedComponentName})`;

  return WithPermissionComponent;
}

export default withPagePermission;
